"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var reviews_1 = require("../routes/reviews");
var fetch_1 = require("../utils/fetch");
exports.default = {
    getMyReviews: function () {
        var _a = reviews_1.default.getMyReviews, url = _a.url, method = _a.method;
        return fetch_1.default(url, {
            method: method,
        });
    },
    getUsersReviews: function (id, params) {
        var _a = reviews_1.default.getUsersReviews, url = _a.url, method = _a.method;
        var newUrl = lodash_1.replace(url, "{uid}", id.toString());
        return fetch_1.default(newUrl, {
            method: method,
        }, params);
    },
    getPendingReviews: function () {
        var _a = reviews_1.default.getPendingReviews, url = _a.url, method = _a.method;
        return fetch_1.default(url, {
            method: method,
        });
    },
    addReviewEmployer: function (id, data) {
        var _a = reviews_1.default.addReviewEmployer, url = _a.url, method = _a.method;
        var newUrl = lodash_1.replace(url, "{jid}", id.toString());
        return fetch_1.default(newUrl, {
            method: method,
            body: JSON.stringify(data),
        });
    },
    addReviewCandidate: function (id, data) {
        var _a = reviews_1.default.addReviewCandidate, url = _a.url, method = _a.method;
        var newUrl = lodash_1.replace(url, "{aid}", id.toString());
        return fetch_1.default(newUrl, {
            method: method,
            body: JSON.stringify(data),
        });
    },
    getAllReviews: function (params) {
        return fetch_1.default("/reviews", { method: "GET" }, params);
    },
    removeReview: function (id) {
        return fetch_1.default("/reviews/" + id, { method: "DELETE" });
    },
};
//# sourceMappingURL=reviews.js.map